const HeaderOfficeAccounting = () => {
  return <div>Header Office Accounting</div>;
};

export default HeaderOfficeAccounting;
